export default "__VITE_ASSET__CZC92fG7__"